// Shared scoring utilities
// Central place to keep weighting logic consistent across dashboards.

export function pct(v) {
  return Number.isFinite(v) ? Math.max(0, Math.min(100, v)) : null;
}

// Generic weighted aggregator that normalises across present metrics.
// inputs: [{ value: number|null, weight: number }]
// returns { score: number|null, confidence: 0..1 }
export function weighted(values) {
  let usedWeight = 0; let acc = 0; let totalWeight = 0;
  for (const v of values) totalWeight += v.weight;
  for (const v of values) if (v.value != null) { usedWeight += v.weight; acc += v.value * v.weight; }
  if (!usedWeight) return { score: null, confidence: 0 };
  return { score: acc / usedWeight, confidence: usedWeight / totalWeight };
}

// Map raw monthly growth % to a profile score (0-100) where modest growth 0-5% is ideal.
export function mapGrowthToProfileScore(g) {
  if (!Number.isFinite(g)) return null;
  if (g < -10) return 30;
  if (g < -5) return 50;
  if (g < 0) return 65;
  if (g <= 5) return 100;
  if (g <= 10) return 85;
  if (g <= 15) return 70;
  if (g <= 25) return 55;
  return 40;
}

// Compute SharePoint collaboration aggregate:
// Weights (nominal): Active 0.5, Headroom 0.3, Growth profile 0.2
// Missing metrics are ignored and weights re-normalised; confidence reflects
// proportion of nominal weight actually represented (0..1).
export function computeSharepointCollabAggregate(activePrevPct, headroomPct, growthPct) {
  const growthProfileScore = mapGrowthToProfileScore(growthPct);
  const agg = weighted([
    { value: activePrevPct, weight: 0.5 },
    { value: headroomPct, weight: 0.3 },
    { value: growthProfileScore, weight: 0.2 }
  ]);
  return { ...agg, growthProfileScore };
}

// Utility to convert coefficient of variation (std/mean) into a stability score.
// Smooth curve: score = 100 * (1 / (1 + cv)) so CV=0 =>100, CV=1 =>50, CV=3 =>25.
export function stabilityScoreFromCV(cv) {
  if (!Number.isFinite(cv) || cv < 0) return null;
  return pct(100 * (1 / (1 + cv)));
}
